module.exports = __webpack_public_path__ + "static/media/androidIns.a81cb6c2.svg";